const CLAIM = "/claim";
const MY_CLAIM = "/my-claims";
const CLAIM_B = "/get-started-v3";
const LENDER = `${CLAIM}/lender`;
const NOT_ELIGIBLE = `${CLAIM}/not-eligible`;
const BANKRUPTSY_CONCENT = `${CLAIM}/bankruptsy-concent`;

const COMPLIANCE ={
  PRE_CONTRAC_CLAIM_PACK: 'https://fair-inc.s3.eu-west-2.amazonaws.com/Templates/Fair+Vehicle+Finance+Claim+Pack+Feb+18+2025.pdf',
  TERMS_AND_CONDITION: 'https://fair-inc.s3.eu-west-2.amazonaws.com/public/Terms.pdf'
}
const LENDER_CATEGORIES = {
  SELF_DECLARED: 'Self Declared',
  VALID8: 'Valid8',
  EQUIFAX: 'Equifax',
  BLACKLISTED: 'Blacklist'
}
const PATHS = {
  CLAIM,
  LENDER,
  NOT_ELIGIBLE,
  BANKRUPTSY_CONCENT,
  INFO: `${CLAIM}/info`,
  CONTACT: `${CLAIM}/contact`,
  ID_VERIFICATION_SELCTION: `${CLAIM}/idv`,
  OPEN_BANKING: `${CLAIM}/open-banking`,
  THREE_QUESTIONS: `${CLAIM}/questions`,
  ID_SELFIE: `${CLAIM}/id-selfie`,
  ID_SELFIE_UPLOAD: `${CLAIM}/id-selfie-upload`,
  CREDIT_REPORT: `${CLAIM}/credit-report`,
  CREDIT_REPORT_DUMMY: `${CLAIM}/credit-report-dummy`,
  NO_CLAIM_FOUND: `${CLAIM}/no-claim-found`,
  PRE_SIGN_CONCENT: `${CLAIM}/pre-signature-concent`,
  SIGN_CLAIM: `${CLAIM}/sign-claim`,
  SUBMIT_CLAIM: `${CLAIM}/submit-claim`,
  MY_CLAIM: `${MY_CLAIM}`,
};

const PATHS_B = {
  CLAIM: CLAIM_B,
  NOT_ELIGIBLE: `${CLAIM_B}/not-eligible`,
  NOT_ELIGIBLE_ALREADY_EXIST: `${CLAIM_B}/not-eligible-already-exist`,
  CREDIT_CHECK: `${CLAIM_B}/credit-check`,
  BANKRUPTSY_CONCENT,
  INFO: `${CLAIM_B}/info`,
  DOB: `${CLAIM_B}/dob`,
  CONTACT: `${CLAIM_B}/contact`,
  // Remained previous /contact to /contact-old as it was not being used, and we needed to use /contact for latest email
  //  phone screen as we have split the user information screen to /info for name dob and /contact for email phone.
  CONTACT_OLD: `${CLAIM_B}/contact-old`,
  ID_VERIFICATION_SELCTION: `${CLAIM_B}/idv`,
  OPEN_BANKING: `${CLAIM_B}/open-banking`,
  THREE_QUESTIONS: `${CLAIM_B}/questions`,
  ID_SELFIE: `${CLAIM_B}/id-selfie`,
  ID_SELFIE_UPLOAD: `/get-started/id-selfie-upload`,
  ID_SELFIE_UPLOAD_PERSONA: `/get-started/id-selfie-upload-persona`,
  ID_SELFIE_DISCLAIMER: `${CLAIM_B}/id-selfie-disclaimer`,
  CREDIT_REPORT: `${CLAIM_B}/credit-report`,
  CREDIT_REPORT_NOT_FOUND: `${CLAIM_B}/credit-report-no-found`,
  CREDIT_REPORT_DUMMY: `${CLAIM_B}/credit-report-dummy`,
  CREDIT_REPORT_RECHECK: `${CLAIM_B}/credit-report-recheck`,
  NO_CLAIM_FOUND: `${CLAIM_B}/no-claim-found`,
  PRE_SIGN_CONCENT: `${CLAIM_B}/pre-signature-concent`,
  SIGN_CLAIM: `${CLAIM_B}/sign-claim`,
  PRE_SIGN_CLAIM: `${CLAIM_B}/pre-sign-claim`,
  SUBMIT_CLAIM: `${CLAIM_B}/submit-claim`,
  MY_CLAIM: `${CLAIM_B}`,
  LUMINATE_DISCLAIMER: `${CLAIM_B}/disclaimer`,
  CLAIM_ALREADY_EXIST_DISCLAIMER: `${CLAIM_B}/claim-disclaimer`,
  MISSOLD_DISCLAIMER: `${CLAIM_B}/mis-sold-confirmation`,
  LENDER: `${CLAIM_B}/lender`,
  EXPERIAN: `${CLAIM_B}/credits-report`,
  LENDER_PREV_ADDRESS: `${CLAIM_B}/lender-previous-address`,
  POSTCODE: `${CLAIM_B}/postcode`,
  CLAIM_SUBMIT: `${CLAIM_B}/claim-submit`,
  CHANGE_ADDRESS: `${CLAIM_B}/info-change-address`,
  CHANGE_DOB: `${CLAIM_B}/info-change-dob`,
  CREDIT_REPORT_ON_IDV: `/get-started/credit-report-on-idv`,
};

const LANG = {
  LETS_GET_STARTED: `Current Address`,
  PREVIOUS_ADDRESS: `Previous Address`,
  PREVIOUS_ADDRES_SUBTITLE: `Please provide the address where you were living when you initially financed the vehicle, as it may be required for verification purposes.`,
  ACCURACY_TEXT:'100% Accuracy Needed',
  MISTAKE_TEXT:'Slightest mistake and we can’t pull your loan information to proceed with the claim.',
  CONTACT_INFO_HEADING: `Please confirm your contact details to be used for communication`,
  CONTACT_INFO_HEADING_B: `Your Most Reliable Contact Details`,
  CONTACT_INFO_SUBTITLE_B: `Enter your email and phone number to receive important updates about your claim.`,
  IDV_SELECTION_HEADING: `To protect you against fraud, please verify your identity through either:`,
  NO_CLAIM_FOUND: `We were unfortunately unable to locate any pre January 2021 motor vehicle loans from a review of your credit report.`,
  NOT_ELIGIBLE: `Unfortunately we do not believe your vehicle qualifies for a claim.`,
  DID_DEALER_DISCLOSED: `Did the dealer disclose the financing commission and/or how it may increase the cost of your finance`,
  IF_YOU_FOUND_LENDER_RECIEVED_COMMISION_LABEL: `If you found out your lenders received a commission on getting you financing, would you have:`,
  ASKED_DEALER_REDUCE_COST_OPT: `Asked dealership to reduce the cost`,
  SHOPED_BETTER_DEAL_OPT: `Shopped for a better deal`,
  REFUSED_FINANCING_OPT: `Refused to take the financing`,
  LETS_FIND_AGREEMENT_TITLE: `Let’s Get Started`,
  CONTACT_INFORMATION_LABEL: `Contact Information`,
  CONTACT_INFORMATION_SUB_HEADING_OLD: 'We need these to share details about your potential refund.',
  CONTACT_INFORMATION_SUB_HEADING: `We need this information to share details about your potential refund.`,
  PROVIDE_INFO_TITLE: `We are able to identify a vast majority of potential claims when your full name, address and date of birth are accurate.`,
  PERSONAL_DETAILS_LABEL: `Your Personal Details:`,
  LUMINATE_DISCLAIMER: "Before we help get your refund, we need to verify your identity by asking three easy questions from your credit report.<br/><br/><span style='color:#e70000;'>Your answers can not be changed, please answer carefully.</span><br/><br/>This process protects against identity theft and helps you get your money faster.",
  CLAIM_ALREADY_EXIST_DISCLAIMER: `It looks like you've already submitted a claim with us!<br /><br />Please check your email for updates.<br /><br />If you can't find it, please contact us at <a style="color: blue; text-decoration: underline; cursor: pointer;" href="mailto:claims@fair.inc">claims@fair.inc</a> for further assistance.`,
  THREE_QUESTIONS_HEADING: "To verify your identity, please answer following simple questions based on your credit report.",
  PRE_SIGNATURE_CONSENT_HEADING: "Required Disclosure",
  UNABLE_TO_APPLY_CLAIM: `PCP refunds are potentially due when the lender has charged a commission that wasn't properly disclosed.<br /><br /> Based upon your answer you aren't entitled to claim a refund.`,
  NO_TITLE_IN_NAME: `Titles are not allowed in the name field`,
};

export { PATHS, LANG, PATHS_B, COMPLIANCE, LENDER_CATEGORIES };
